// extracted by mini-css-extract-plugin
module.exports = {"body":"Product_body__1wR5D","container":"Product_container__2OZEA"};